var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.658,
    height: 96,
    viewBox: "0 0 97.658 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_07-Broken_copy_3",
    "data-name": "07-Broken copy 3",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M93.609,34.006a8.46,8.46,0,0,1-1.622,4.817c-3.939,5.578-10.345,14.45-14.781,20.59A16.568,16.568,0,0,1,63.8,66.249H34.172l-3.31,3.31L11,49.7l7.018-7.018a9.919,9.919,0,0,1,7.034-2.913h35.6a6.6,6.6,0,0,1,6.306,4.618c2.88-2.7,5.843-5.479,8.541-8.028,2.632-2.516,5-4.783,6.786-6.554a6.714,6.714,0,0,1,9.352-.348A6.076,6.076,0,0,1,93.609,34.006Z",
    transform: "translate(5.241 16.199)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M93.609,34.006a7.544,7.544,0,0,1-.232,1.7,6.034,6.034,0,0,0-1.738-2.946,6.714,6.714,0,0,0-9.352.348c-1.788,1.771-4.154,4.039-6.786,6.554-2.185,2.069-4.535,4.27-6.885,6.472-.546.53-1.109,1.043-1.655,1.556a6.319,6.319,0,0,0-1.92-2.946,6.531,6.531,0,0,0-4.386-1.672h-35.6a9.919,9.919,0,0,0-7.034,2.913l-5.363,5.363L11,49.7l7.018-7.018a9.919,9.919,0,0,1,7.034-2.913h35.6a6.6,6.6,0,0,1,6.306,4.618c.348-.314.679-.646,1.026-.96v-.017c2.549-2.383,5.131-4.8,7.514-7.051,2.632-2.516,5-4.783,6.786-6.554a6.714,6.714,0,0,1,9.352-.348A6.076,6.076,0,0,1,93.609,34.006Z",
    transform: "translate(5.241 16.199)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M70.655,12,45.827,43.448,21,12Z",
    transform: "translate(11.793 5.896)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M47.552,12,39.276,41.793,31,12Z",
    transform: "translate(18.345 5.896)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M37.552,17.9H21L29.276,3Z",
    transform: "translate(11.793 0)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M42.552,3,34.276,17.9,26,3Z",
    transform: "translate(15.069 0)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M47.552,17.9H31L39.276,3Z",
    transform: "translate(18.345 0)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M52.552,3,44.276,17.9,36,3Z",
    transform: "translate(21.62 0)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M57.552,17.9H41L49.276,3Z",
    transform: "translate(24.896 0)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M56.948,40.173v.248A8.279,8.279,0,0,1,48.672,48.7H30.465a1.655,1.655,0,1,1,0-3.31H48.672a4.945,4.945,0,0,0,4.965-4.966,5.285,5.285,0,0,0-.232-1.506.389.389,0,0,1-.033-.132,1.622,1.622,0,0,1,1.109-1.937c.017,0,.05-.017.066-.017a6.65,6.65,0,0,1,.745,1.589c.348-.314.679-.646,1.026-.96a1.523,1.523,0,0,1,.232.463,8.688,8.688,0,0,1,.4,2.251Z",
    transform: "translate(16.91 22.164)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 14.044,
    height: 37.451,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 3, 72.515)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M16.884,56.194a10.269,10.269,0,0,1-.61-13.85L12.931,39,3,48.929,29.481,75.414l3.31-3.31Z",
    transform: "translate(0 23.586)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M21.587,18.242H11.656a1.655,1.655,0,0,1,0-3.31h9.931a1.655,1.655,0,1,1,0,3.31Zm-9.931,9.932a1.655,1.655,0,0,1-.524-3.226l9.931-3.31a1.655,1.655,0,0,1,1.047,3.141l-9.931,3.31a1.647,1.647,0,0,1-.524.086Zm9.931-16.552a1.647,1.647,0,0,1-.524-.086l-9.931-3.31A1.655,1.655,0,1,1,12.18,5.085L22.111,8.4a1.655,1.655,0,0,1-.524,3.226Zm72.827,6.62H84.484a1.655,1.655,0,1,1,0-3.31h9.931a1.655,1.655,0,0,1,0,3.31Zm0,9.932a1.647,1.647,0,0,1-.524-.086l-9.931-3.31a1.655,1.655,0,1,1,1.047-3.141l9.931,3.31a1.655,1.655,0,0,1-.524,3.226ZM84.484,11.622A1.655,1.655,0,0,1,83.96,8.4l9.931-3.31a1.655,1.655,0,0,1,1.047,3.141l-9.931,3.31a1.647,1.647,0,0,1-.524.086Z",
    transform: "translate(4.585 1.31)",
    fill: "#3666f6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandDiamond);
export default __webpack_public_path__ + "static/media/hand-diamond.f2313d3951586a8f092adb32b71af71a.svg";
export { ForwardRef as ReactComponent };